module.exports = __webpack_public_path__ + "static/media/SIG4.c6fc3a29.png";